import React from 'react';

const DAY_MS = 24 * 60 * 60 * 1000;

// Dải số liệu đầu mỗi mục. tone: good | warn | bad
export function KpiStrip({ items }) {
  return (
    <div className="adm-kpis">
      {items.map((k) => (
        <div key={k.label} className={`adm-kpi${k.tone ? ` is-${k.tone}` : ''}`}>
          <div className="adm-kpi-label">{k.label}</div>
          <div className="adm-kpi-value">{k.value}</div>
          {k.trend}
          {k.note && <div className="adm-kpi-note">{k.note}</div>}
        </div>
      ))}
    </div>
  );
}

// Doanh thu theo ngày trong 14 ngày gần nhất, tính từ các đơn đã thanh toán
export function RevenueTrend({ orders, days = 14 }) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const buckets = Array.from({ length: days }, () => 0);
  orders.forEach((o) => {
    if (o.status !== 'PAID' || !o.paidAt) return;
    const d = new Date(o.paidAt);
    d.setHours(0, 0, 0, 0);
    const idx = days - 1 - Math.round((today - d) / DAY_MS);
    if (idx >= 0 && idx < days) buckets[idx] += o.paidAmount ?? o.amount ?? 0;
  });
  const max = Math.max(...buckets);
  if (max === 0) return null;

  return (
    <div className="adm-trend" role="img" aria-label={`Doanh thu ${days} ngày gần nhất`}>
      {buckets.map((v, i) => (
        <span
          key={i}
          className={i === days - 1 ? 'is-today' : undefined}
          style={{ height: `${Math.max(7, (v / max) * 100)}%` }}
          title={v ? new Intl.NumberFormat('vi-VN').format(v) + 'đ' : 'Không có đơn'}
        />
      ))}
    </div>
  );
}

// Số ngày còn lại tới hạn (âm nếu đã quá hạn)
export function daysUntil(date) {
  if (!date) return null;
  const end = new Date(date);
  end.setHours(0, 0, 0, 0);
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  return Math.round((end - now) / DAY_MS);
}

// Dấu HSD: hạn gói hội viên in như hạn dùng trên hộp thuốc
export function HsdStamp({ expiresAt }) {
  if (!expiresAt) {
    return (
      <span className="adm-hsd is-forever">
        <span className="adm-hsd-tag">HSD</span>
        <span className="adm-hsd-left">Không thời hạn</span>
      </span>
    );
  }
  const left = daysUntil(expiresAt);
  const tone = left < 0 ? ' is-bad' : left <= 7 ? ' is-warn' : '';
  const leftText = left < 0 ? `Quá hạn ${-left} ngày` : left === 0 ? 'Hết hạn hôm nay' : `Còn ${left} ngày`;
  return (
    <span className={`adm-hsd${tone}`}>
      <span className="adm-hsd-tag">HSD</span>
      <span className="adm-hsd-date">{new Date(expiresAt).toLocaleDateString('vi-VN')}</span>
      <span className="adm-hsd-left">{leftText}</span>
    </span>
  );
}

export function StatusPill({ tone, children }) {
  return <span className={`adm-pill${tone ? ` is-${tone}` : ''}`}>{children}</span>;
}

export function Panel({ title, meta, tools, children, pad }) {
  const hasBar = title || meta || tools;
  return (
    <section className="adm-panel">
      {hasBar && (
        <div className="adm-panel-bar">
          {title ? <h2>{title}</h2> : tools}
          {title && tools}
          {meta && <div className="adm-panel-meta">{meta}</div>}
        </div>
      )}
      {pad ? <div className="adm-panel-pad">{children}</div> : children}
    </section>
  );
}
